// Generated with util/create-component.js
import React from 'react'

import { ButtonGroupProps } from './ButtonGroup.types'

const ButtonGroup: React.FC<ButtonGroupProps> = ({ children, size = 'md' }) => {
    const mappedButtons = React.Children.map(children, (child: React.ReactElement) => {
        return React.cloneElement(child, { size })
    })
    return <div className='r-button-group'>{mappedButtons}</div>
}

export default ButtonGroup
